import { getUnifiedAuthConfigUrl } from './Api';
import { AuthenticateError } from './LowLevelUnifiedAuth';
import { hubletApi, resolveApi } from 'hub-http/middlewares/core';
import { buildUrl } from 'hub-http/helpers/url';
export function fetchAuthConfigForUnifiedAuth(http, authenticatorId, appName, oAuthScope, mcp, appId) {
  return async () => {
    const authFlow = await http.get(buildUrl({
      hostname: resolveApi(hubletApi('app', 'hubspot')),
      path: getUnifiedAuthConfigUrl(authenticatorId, appName)
    }));
    return {
      appName,
      appIcon: '',
      oAuthScope,
      mcp,
      authFlow,
      appId,
      makeAuthorizeUrlDescriptor() {
        return {
          hostname: resolveApi(hubletApi('app', 'hubspot')),
          path: `/api/unified-auth/v1/authenticators/${authenticatorId}/authorize`
        };
      },
      finishAuthFlow(payload) {
        return http.post(buildUrl({
          hostname: resolveApi(hubletApi('app', 'hubspot')),
          path: `/api/unified-auth/v1/authenticators/${authenticatorId}/secret`
        }), {
          data: payload
        }).then(finishPayload => {
          if (typeof finishPayload === 'object' && 'status' in finishPayload && finishPayload.status === 'error') {
            throw new AuthenticateError(finishPayload.message, finishPayload.upstreamErrorMessage);
          } else {
            return finishPayload;
          }
        });
      }
    };
  };
}